export class LoraForwarderChirpStackConfig {

  public General?: LoraForwarderChirpStackConfigGeneral;
  public Filters?: LoraForwarderChirpStackConfigFilters;
  public Backend?: LoraForwarderChirpStackConfigBackend;
  public Integration?: LoraForwarderChirpStackConfigIntegration;
  public Metrics?: LoraForwarderChirpStackConfigMetrics;

  constructor(config: any) {
    if (config.general) {
      this.General = new LoraForwarderChirpStackConfigGeneral(config.general);
    }

    if (config.filters) {
      this.Filters = new LoraForwarderChirpStackConfigFilters(config.filters);
    }

    switch (config.backend.type) {
      case LoraForwarderChirpStackConfigBackendType.SemtechUdp:
        this.Backend = new LoraForwarderChirpStackConfigBackendSemtechUdp(config.backend);
        break;

      case LoraForwarderChirpStackConfigBackendType.BasicStation:
        this.Backend = new LoraForwarderChirpStackConfigBackendBasicStation(config.backend);
        break;

      default:
        this.Backend = new LoraForwarderChirpStackConfigBackend(config.backend);
        break;
    }

    if (config.integration) {
      this.Integration = new LoraForwarderChirpStackConfigIntegration(config.integration);
    }

    if (config.metrics) {
      this.Metrics = new LoraForwarderChirpStackConfigIntegration(config.metrics);
    }
  }
}

export class LoraForwarderChirpStackConfigGeneral {
  public LogLevel?: number;

  constructor(config: any) {
    this.LogLevel = config.log_level;
  }
}

export class LoraForwarderChirpStackConfigFilters {
  public NetIds?: string[];
  public JoinEuis?: string[];


  constructor(config: any) {
    this.NetIds = config.net_ids;
    this.JoinEuis = config.join_euis;
  }
}

export enum LoraForwarderChirpStackConfigBackendType {
  SemtechUdp = 'semtech_udp',
  BasicStation = 'basic_station',
}

export class LoraForwarderChirpStackConfigBackend {
  public Type: LoraForwarderChirpStackConfigBackendType;

  constructor(config: any) {
    this.Type = config.type;
  }
}

export class LoraForwarderChirpStackConfigBackendSemtechUdp extends LoraForwarderChirpStackConfigBackend {

  public UdpBind: string;
  public SkipCrcCheck?: boolean;
  public FakeRxTime?: boolean;

  constructor(config: any) {
    super(config);

    config = config.semtech_udp;
    this.UdpBind = config.udp_bind;
    this.SkipCrcCheck = config.skip_crc_check;
    this.FakeRxTime = config.fake_rx_time;
  }
}

export class LoraForwarderChirpStackConfigBackendBasicStation extends LoraForwarderChirpStackConfigBackend {

  public Bind: string;
  public TlsCert?: string;
  public TlsKey?: string;

  public CaCert?: string;
  public PingInterval?: string;
  public ReadTimeout?: string;
  public WriteTimeout?: string;
  public Region?: string;

  public FrequencyMin?: number;
  public FrequencyMax?: number;

  constructor(config: any) {
    super(config);

    config = config.basic_station;
    this.Bind = config.bind;
    this.TlsCert = config.tls_cert;
    this.TlsKey = config.tls_key;
    this.CaCert = config.ca_cert;
    this.PingInterval = config.ping_interval;
    this.ReadTimeout = config.read_timeout;
    this.WriteTimeout = config.write_timeout;
    this.Region = config.region;
    this.FrequencyMin = config.frequency_min;
    this.FrequencyMax = config.frequency_max;
  }
}

export enum LoraForwarderChirpStackConfigIntegrationMarshaller {
  Protobuf = 'protobuf',
  Json = 'json',
}

export class LoraForwarderChirpStackConfigIntegration {

  public Marshaler: LoraForwarderChirpStackConfigIntegrationMarshaller;
  public Mqtt?: LoraForwarderChirpStackConfigIntegrationMqtt;

  constructor(config: any) {
    this.Marshaler = config.marshaler;

    if (config.mqtt) {
      this.Mqtt = new LoraForwarderChirpStackConfigIntegrationMqtt(config.mqtt);
    }
  }
}

export class LoraForwarderChirpStackConfigIntegrationMqtt {

  public EventTopicTemplate?: string;
  public CommandTopicTtemplate?: string;
  public MaxReconnectInterval?: string;

  public Authentication?: LoraForwarderChirpStackConfigIntegrationMqttAuth;

  constructor(config: any) {
    this.EventTopicTemplate = config.event_topic_template;
    this.CommandTopicTtemplate = config.command_topic_template;
    this.MaxReconnectInterval = config.max_reconnect_interval;

    if (config.auth) {
      switch (config.auth.type) {
        case LoraForwarderChirpStackConfigIntegrationMqttAuthType.Generic:
          this.Authentication = new LoraForwarderChirpStackConfigIntegrationMqttAuthGeneric(config.auth);
          break;

        default:
          this.Authentication = new LoraForwarderChirpStackConfigIntegrationMqttAuth(config.auth);
          break;
      }
    }
  }
}

export enum LoraForwarderChirpStackConfigIntegrationMqttAuthType {
  Generic = 'generic',
  GoogleCloudPlatoform = 'gcp_cloud_iot_core',
  AzureIot = 'azure_iot_hub',
}

export class LoraForwarderChirpStackConfigIntegrationMqttAuth {

  public Type: string;

  constructor(config: any) {
    this.Type = config.type;
  }
}

export class LoraForwarderChirpStackConfigIntegrationMqttAuthGeneric extends LoraForwarderChirpStackConfigIntegrationMqttAuth {

  public Server: string;
  public Username?: string;
  public Password?: string;

  public Qos?: number;
  public CleanSession?: boolean;

  public ClientId?: string;
  public CaCert?: string;
  public TlsCert?: string;
  public TlsKey?: string;

  constructor(config: any) {
    super(config);

    config = config.generic;
    this.Server = config.server;
    this.Username = config.username;
    this.Password = config.password;
    this.Qos = config.qos;
    this.CleanSession = config.clean_session;
    this.ClientId = config.client_id;
    this.CaCert = config.ca_cert;
    this.TlsCert = config.tls_cert;
    this.TlsKey = config.tls_key;
  }
}

export class LoraForwarderChirpStackConfigMetrics {
}

export class LoraForwarderChirpStackConfigMetricsPrometheus extends LoraForwarderChirpStackConfigMetrics {

  public EndpointEnabled: boolean;
  public Bind: boolean;

  constructor(config: any) {
    super();

    this.EndpointEnabled = config.endpoint_enabled;
    this.Bind = config.bind;
  }
}

export class LoraForwarderChirpStackConfigMetadata {
}
